import { Box } from '@mui/material';

const BasicGapContainer = ({ children }: any) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {children}
    </Box>
  );
};

export default BasicGapContainer;
